import VueRouter from 'vue-router';

import Login from './components/Auth/Login.vue';
import ForgotPassword from './components/Auth/ForgotPassword.vue';
import ResetPassword from './components/Auth/ResetPassword.vue';
import ResetExpiredPassword from './components/Auth/ResetExpiredPassword.vue';
import MainApplication from './components/MainApplication.vue';
import Dashboard from './components/Dashboard.vue';
import PageNotFound from './components/PageNotFound.vue';
import Search from './components/Search.vue';
import AllClaims from './components/AllClaims.vue';
import Agents from './components/Agent/Table.vue';
import AgentForm from './components/Agent/Form.vue';
import CreditHireOrganisations from './components/CreditHireOrganisation/Table.vue';
import CreditHireOrganisationForm from './components/CreditHireOrganisation/Form.vue';
import Customers from './components/Modules/Customers/Table.vue';
import CustomersForm from './components/Modules/Customers/Form.vue';
import Companies from './components/Modules/Companies/Table.vue';
import CompanyContacts from './components/Modules/Companies/Contacts.vue';
import CompaniesSearch from './components/Modules/Companies/Search.vue';

import FirstNoticeOfLossPlus from './components/Modules/FirstNoticeOfLossPlus/Table.vue';
import FirstNoticeOfLossPlusForm from './components/Modules/FirstNoticeOfLossPlus/Form.vue';
import FirstNoticeOfLossPlusEdit from './components/Modules/FirstNoticeOfLossPlus/Edit.vue';
import FirstNoticeOfLossPlusEditPartiesAddThirdParty from './components/Modules/FirstNoticeOfLossPlus/Sections/Party/ThirdParty/AddThirdParty.vue';
import FirstNoticeOfLossPlusEditPartiesEditThirdParty from './components/Modules/FirstNoticeOfLossPlus/Sections/Party/ThirdParty/EditThirdParty.vue';
import FirstNoticeOfLossPlusEditPartiesAddOccupant from './components/Modules/FirstNoticeOfLossPlus/Sections/Party/Occupant/AddOccupant.vue';
import FirstNoticeOfLossPlusEditPartiesEditOccupant from './components/Modules/FirstNoticeOfLossPlus/Sections/Party/Occupant/EditOccupant.vue';
import FirstNoticeOfLossPlusEditPartiesAddWitness from './components/Modules/FirstNoticeOfLossPlus/Sections/Party/Witness/AddWitness.vue';
import FirstNoticeOfLossPlusEditPartiesEditWitness from './components/Modules/FirstNoticeOfLossPlus/Sections/Party/Witness/EditWitness.vue';

import FirstNoticeOfLoss from './components/Modules/FirstNoticeOfLoss/Table.vue';
import FirstNoticeOfLossForm from './components/Modules/FirstNoticeOfLoss/Form.vue';
import FirstNoticeOfLossComplete from './components/Modules/FirstNoticeOfLoss/Complete.vue';
import NewClaimsAdvice from './components/Modules/NewClaimsAdvice/Table.vue';
import NewClaimsAdviceEmail from './components/Modules/NewClaimsAdvice/Email.vue';
import NewClaimsAdviceForm from './components/Modules/NewClaimsAdvice/Form.vue';
import HireMonitoring from './components/Modules/HireMonitoring/Table.vue';
import HireMonitoringForm from './components/Modules/HireMonitoring/Form.vue';
import HireMonitoringPaymentPack from './components/Modules/HireMonitoring/PaymentPack.vue';
import HireMonitoringEmail from './components/Modules/HireMonitoring/Email.vue';
import HireMonitoringSendToVerify from './components/Modules/HireMonitoring/SendToVerify.vue';

import Recovery from './components/Modules/Recovery/Table.vue';
import RecoveryForm from './components/Modules/Recovery/Form.vue';
import RecoverySendToVerify from './components/Modules/Recovery/SendToVerify.vue';

import Rejected from './components/Modules/Rejected/Table.vue';
import RejectedForm from './components/Modules/Rejected/Form.vue';

import Closed from './components/Modules/Closed/Table.vue';
import ClosedForm from './components/Modules/Closed/Form.vue';

import Fleet from './components/Modules/Fleet/Table.vue';
import FleetForm from './components/Modules/Fleet/Form.vue';
import ViewVehicle from './components/Modules/Fleet/View.vue';
import ServiceForm from './components/Modules/Fleet/Service/Form.vue';

import Defleet from './components/Modules/Defleet/Table.vue';
import DefleetForm from './components/Modules/Defleet/Form.vue';

import Qualification from './components/Modules/Qualification/Table.vue';
import QualificationForm from './components/Modules/Qualification/Form.vue';
import QualificationEditPartiesThirdParty from './components/Modules/Qualification/Sections/Party/ThirdParty.vue';
import QualificationEditPartiesOccupant from './components/Modules/Qualification/Sections/Party/Occupant.vue';
import QualificationEditPartiesWitness from './components/Modules/Qualification/Sections/Party/Witness.vue';

import Deployment from './components/Modules/Deployment/Table.vue';
import DeploymentForm from './components/Modules/Deployment/Form.vue';
import ClientDeploymentForm from './components/Modules/Deployment/Client.vue';
import PartyHireForm from './components/Modules/Deployment/Hire.vue';
import PartyHireFormComplete from './components/Modules/Deployment/HireComplete.vue';

import Penalties from './components/Modules/Penalties/Table.vue';
import PenaltyForm from './components/Modules/Penalties/Form.vue';

import Recharges from './components/Modules/Recharges/Table.vue';
import RechargeForm from './components/Modules/Recharges/Form.vue';

import Runs from './components/Modules/Run/Table.vue';
import RunForm from './components/Modules/Run/Form.vue';
import RunItem from './components/Modules/Run/Item.vue';
import RescheduleJob from './components/Modules/Run/RescheduleJob.vue';

import Jobs from './components/Modules/Job/Table.vue';
import JobForm from './components/Modules/Job/Form.vue';
import GenerateDocusign from './components/Modules/Job/GenerateDocusign.vue';
import ViewJob from './components/Modules/Job/View.vue';

import PDI from './components/Modules/PDI/Table.vue';
import PDIForm from './components/Modules/PDI/Form.vue';

import Users from './components/Modules/Users/Table.vue';

import Insurers from './components/Modules/Insurers/Table.vue';

import MI from './components/Modules/MI/Form.vue';

export default new VueRouter({
  mode: 'history',

  routes: [
    { path: '/login', component: Login },
    { path: '/forgot-password', component: ForgotPassword },
    { path: '/reset-expired-password', component: ResetExpiredPassword },
    { path: '/reset-password', component: ResetPassword },
    { path: '/', redirect: '/dashboard' },

    {
      path: '/',
      component: MainApplication,
      children: [
        { path: '/404', component: PageNotFound },
        { path: 'dashboard', component: Dashboard },
        { path: '/search', component: Search },
        {
          path: '/all-claims',
          component: AllClaims,
          meta: { permission: 'claims.allClaims' }
        },

        // { path: '/agents', component: Agents },
        // { path: '/agents/create', component: AgentForm },
        // {
        //   path: '/agents/:identifier',
        //   component: AgentForm,
        //   props: route => ({ agent: route.params.identifier })
        // },

        // {
        //   path: '/credit-hire-organisations',
        //   component: CreditHireOrganisations
        // },
        // {
        //   path: '/credit-hire-organisations/create',
        //   component: CreditHireOrganisationForm
        // },
        // {
        //   path: '/credit-hire-organisations/:identifier',
        //   component: CreditHireOrganisationForm,
        //   props: route => ({ creditHireOrganisation: route.params.identifier })
        // },

        {
          path: '/customers',
          component: Customers,
          meta: { permission: 'companies.create' }
        },
        {
          path: '/customers/create',
          component: CustomersForm,
          meta: { permission: 'companies.create' }
        },
        {
          path: '/customers/:identifier',
          component: CustomersForm,
          props: route => ({ customer: route.params.identifier }),
          meta: { permission: 'companies.create' }
        },

        {
          path: '/companies',
          component: Companies,
          meta: { permission: 'companies.read' }
        },
        {
          path: '/companies/search',
          component: CompaniesSearch,
          meta: { permission: 'companies.create' }
        },
        {
          path: '/companies/:company/contacts',
          component: CompanyContacts,
          props: route => ({ company: route.params.company }),
          meta: { permission: 'companies.create' }
        },
        {
          path: '/insurers',
          component: Insurers,
          meta: { permission: 'insurers.read' }
        },

        {
          path: '/first-notice-of-loss-plus',
          component: FirstNoticeOfLossPlus,
          meta: { permission: 'claims.fnol' }
        },
        {
          path: '/first-notice-of-loss-plus/create',
          component: FirstNoticeOfLossPlusForm,
          meta: { permission: 'claims.fnol' }
        },
        {
          path: '/first-notice-of-loss-plus/:incident',
          component: FirstNoticeOfLossPlusEdit,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.fnol' }
        },
        {
          path: '/first-notice-of-loss-plus/:incident/parties/third-party',
          component: FirstNoticeOfLossPlusEditPartiesAddThirdParty,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.fnol' }
        },
        {
          path:
            '/first-notice-of-loss-plus/:incident/parties/third-party/:thirdParty',
          component: FirstNoticeOfLossPlusEditPartiesEditThirdParty,
          props: route => ({
            incident: route.params.incident,
            thirdParty: route.params.thirdParty
          }),
          meta: { permission: 'claims.fnol' }
        },
        {
          path: '/first-notice-of-loss-plus/:incident/parties/occupant',
          component: FirstNoticeOfLossPlusEditPartiesAddOccupant,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.fnol' }
        },
        {
          path:
            '/first-notice-of-loss-plus/:incident/parties/occupant/:occupant',
          component: FirstNoticeOfLossPlusEditPartiesEditOccupant,
          props: route => ({
            incident: route.params.incident,
            occupant: route.params.occupant
          }),
          meta: { permission: 'claims.fnol' }
        },
        {
          path: '/first-notice-of-loss-plus/:incident/parties/witness',
          component: FirstNoticeOfLossPlusEditPartiesAddWitness,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.fnol' }
        },
        {
          path: '/first-notice-of-loss-plus/:incident/parties/witness/:witness',
          component: FirstNoticeOfLossPlusEditPartiesEditWitness,
          props: route => ({
            incident: route.params.incident,
            witness: route.params.witness
          }),
          meta: { permission: 'claims.fnol' }
        },

        {
          path: '/first-notice-of-loss',
          component: FirstNoticeOfLoss,
          meta: { permission: 'claims.fnol' }
        },
        {
          path: '/first-notice-of-loss/:incident',
          component: FirstNoticeOfLossForm,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.fnol' }
        },
        {
          path: '/first-notice-of-loss/:incident/complete',
          component: FirstNoticeOfLossComplete,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.fnol' }
        },

        {
          path: '/qualification',
          component: Qualification,
          meta: { permission: 'claims.qualification' }
        },
        {
          path: '/qualification/:incident',
          component: QualificationForm,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.qualification' }
        },
        {
          path: '/qualification/:incident/parties/third-party',
          component: QualificationEditPartiesThirdParty,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.qualification' }
        },
        {
          path: '/qualification/:incident/parties/third-party/:thirdParty',
          component: QualificationEditPartiesThirdParty,
          props: route => ({
            incident: route.params.incident,
            thirdParty: route.params.thirdParty
          }),
          meta: { permission: 'claims.qualification' }
        },
        {
          path: '/qualification/:incident/parties/occupant',
          component: QualificationEditPartiesOccupant,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.qualification' }
        },
        {
          path: '/qualification/:incident/parties/occupant/:occupant',
          component: QualificationEditPartiesOccupant,
          props: route => ({
            incident: route.params.incident,
            occupant: route.params.occupant
          }),
          meta: { permission: 'claims.qualification' }
        },
        {
          path: '/qualification/:incident/parties/witness',
          component: QualificationEditPartiesWitness,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.qualification' }
        },
        {
          path: '/qualification/:incident/parties/witness/:witness',
          component: QualificationEditPartiesWitness,
          props: route => ({
            incident: route.params.incident,
            witness: route.params.witness
          }),
          meta: { permission: 'claims.qualification' }
        },

        {
          path: '/deployment',
          component: Deployment,
          meta: { permission: 'claims.deployment' }
        },
        {
          path: '/deployment/:incident',
          component: DeploymentForm,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.deployment' }
        },
        {
          path: '/deployment/:incident/party/:party/client/:client',
          component: ClientDeploymentForm,
          props: route => ({
            incident: route.params.incident,
            client: route.params.client,
            party: route.params.party
          }),
          meta: { permission: 'claims.deployment' }
        },
        {
          path: '/deployment/:incident/party/:party/hire/:hire',
          component: PartyHireForm,
          props: route => ({
            incident: route.params.incident,
            hire: route.params.hire,
            party: route.params.party
          }),
          meta: { permission: 'claims.deployment' }
        },
        {
          path: '/deployment/:incident/party/:party/hire/:hire/complete',
          component: PartyHireFormComplete,
          props: route => ({
            incident: route.params.incident,
            hire: route.params.hire,
            party: route.params.party
          }),
          meta: { permission: 'claims.deployment' }
        },

        {
          path: '/claim-monitoring',
          component: HireMonitoring,
          meta: { permission: 'claims.claimsMonitoring' }
        },
        {
          path: '/claim-monitoring/:incident',
          component: HireMonitoringForm,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.claimsMonitoring' }
        },
        {
          path: '/claim-monitoring/:incident/payment-pack',
          component: HireMonitoringPaymentPack,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.claimsMonitoring' }
        },
        {
          path: '/claim-monitoring/:incident/email',
          component: HireMonitoringEmail,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.claimsMonitoring' }
        },
        {
          path: '/claim-monitoring/:incident/send-to-verify',
          component: HireMonitoringSendToVerify,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.claimsMonitoring' }
        },

        {
          path: '/recovery',
          component: Recovery,
          meta: { permission: 'claims.recovery' }
        },
        {
          path: '/recovery/:incident',
          component: RecoveryForm,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.recovery' }
        },
        {
          path: '/recovery/:incident/send-to-verify',
          component: RecoverySendToVerify,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.recovery' }
        },

        {
          path: '/rejected',
          component: Rejected,
          meta: { permission: 'claims.rejected' }
        },
        {
          path: '/rejected/:incident',
          component: RejectedForm,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.rejected' }
        },

        {
          path: '/closed',
          component: Closed,
          meta: { permission: 'claims.closed' }
        },
        {
          path: '/closed/:incident',
          component: ClosedForm,
          props: route => ({ incident: route.params.incident }),
          meta: { permission: 'claims.closed' }
        },

        {
          path: '/fleet',
          component: Fleet,
          meta: { permission: 'fleet.read' }
        },
        {
          path: '/fleet/create',
          component: FleetForm,
          meta: { permission: 'fleet.create' }
        },
        {
          path: '/fleet/:identifier',
          component: ViewVehicle,
          props: route => ({ identifier: route.params.identifier }),
          meta: { permission: 'fleet.read' }
        },
        {
          path: '/fleet/:identifier/edit',
          component: FleetForm,
          props: route => ({ identifier: route.params.identifier }),
          meta: { permission: 'fleet.update' }
        },
        {
          path: '/fleet/:identifier/services',
          component: ServiceForm,
          props: route => ({ identifier: route.params.identifier }),
          meta: { permission: 'fleet.read' }
        },
        {
          path: '/fleet/:identifier/services/:service',
          component: ServiceForm,
          props: route => ({
            identifier: route.params.identifier,
            service: route.params.service
          }),
          meta: { permission: 'fleet.update' }
        },
        {
          path: '/defleet',
          component: Defleet,
          meta: { permission: 'fleet.delete' }
        },
        {
          path: '/defleet/:identifier',
          component: DefleetForm,
          props: route => ({ identifier: route.params.identifier }),
          meta: { permission: 'fleet.delete' }
        },

        {
          path: '/penalties',
          component: Penalties,
          meta: { permission: 'penalties.create' }
        },
        {
          path: '/penalties/create',
          component: PenaltyForm,
          meta: { permission: 'penalties.create' }
        },
        {
          path: '/penalties/:identifier/edit',
          component: PenaltyForm,
          props: route => ({ identifier: route.params.identifier }),
          meta: { permission: 'penalties.update' }
        },

        {
          path: '/recharges',
          component: Recharges,
          meta: { permission: 'recharges.read' }
        },
        {
          path: '/recharges/create',
          component: RechargeForm,
          meta: { permission: 'recharges.create' }
        },
        {
          path: '/recharges/:identifier/edit',
          component: RechargeForm,
          props: route => ({ identifier: route.params.identifier }),
          meta: { permission: 'recharges.update' }
        },

        {
          path: '/runs',
          component: Runs,
          meta: { permission: 'runs.create' }
        },
        {
          path: '/runs/create',
          component: RunForm,
          meta: { permission: 'runs.create' }
        },
        {
          path: '/runs/:identifier/edit',
          component: RunForm,
          props: route => ({ identifier: route.params.identifier }),
          meta: { permission: 'runs.update' }
        },
        {
          path: '/runs/:runIdentifier/jobs/:jobIdentifier/reschedule',
          component: RescheduleJob,
          props: route => ({
            runIdentifier: route.params.runIdentifier,
            jobIdentifier: route.params.jobIdentifier
          }),
          meta: { permission: 'runs.read' }
        },
        {
          path: '/runs/:runIdentifier/items/:itemIdentifier',
          component: RunItem,
          props: route => ({
            runIdentifier: route.params.runIdentifier,
            itemIdentifier: route.params.itemIdentifier
          }),
          meta: { permission: 'runs.read' }
        },

        {
          path: '/jobs',
          component: Jobs,
          meta: { permission: 'jobs.create' }
        },
        {
          path: '/jobs/create',
          component: JobForm,
          meta: { permission: 'jobs.create' }
        },
        {
          path: '/jobs/:id',
          component: ViewJob,
          props: route => ({ id: route.params.id }),
          meta: { permission: 'jobs.create' }
        },
        {
          path: '/jobs/:id/edit',
          component: JobForm,
          props: route => ({ id: route.params.id }),
          meta: { permission: 'jobs.update' }
        },
        {
          path: '/jobs/:id/generate-docusign',
          component: GenerateDocusign,
          props: route => ({ id: route.params.id }),
          meta: { permission: 'jobs.update' }
        },

        {
          path: '/pdi-queue',
          component: PDI,
          meta: { permission: 'pdi.read' }
        },
        {
          path: '/pdi-queue/:id',
          component: PDIForm,
          props: route => ({ id: route.params.id }),
          meta: { permission: 'pdi.update' }
        },

        {
          path: '/users',
          component: Users,
          meta: { permission: 'users.create' }
        },
        {
          path: '/mi',
          component: MI,
          meta: { permission: 'mi.read' }
        }
      ]
    },
    { path: '*', redirect: '/404' }
  ]
});
